import React, { useEffect, useRef, useState } from 'react';
import { Grow, Tooltip, Zoom, Select, MenuItem } from '@mui/material';
import {
	ArrowDownward,
	AttachFile,
	InsertEmoticon,
	Send,
} from '@mui/icons-material';
import SmsIcon from '@mui/icons-material/Sms';
import TryIcon from '@mui/icons-material/Try';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ContactsIcon from '@mui/icons-material/Contacts';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NotesIcon from '@mui/icons-material/Notes';
import MicIcon from '@mui/icons-material/Mic';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InternalNoteComposer from './InternalNoteComposer';
import './InternalNotes.css';
// @ts-ignore
import { Emoji, NimblePicker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import '../../styles/EmojiPicker.css';
import PubSub from 'pubsub-js';
import FileInput from '../FileInput';
import { translateHTMLInputToText } from '@src/helpers/Helpers';
import VoiceRecord from '../VoiceRecord';
import {
	EMOJI_SET,
	EMOJI_SHEET_SIZE,
	EVENT_TOPIC_EMOJI_PICKER_VISIBILITY,
	EVENT_TOPIC_FOCUS_MESSAGE_INPUT,
	EVENT_TOPIC_REQUEST_MIC_PERMISSION,
} from '@src/Constants';
import { replaceEmojis } from '@src/helpers/EmojiHelper';
import { useTranslation } from 'react-i18next';
import ContactsModal from '../ContactsModal';
import LocationModal from '../LocationModal';
import data from 'emoji-mart/data/facebook.json';
import QuickActionsMenu from '@src/components/QuickActionsMenu';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import api from '@src/api/axiosInstance';
import './WritingAssistant.css';
import TemplateAssistant from './TemplateAssistant';
import TranslateIcon from '@mui/icons-material/Translate';
import {translationLanguages} from '@src/helpers/Translation';
import useChatFooter from '@src/components/ChatFooter/useChatFooter';
import { useIsUserActionsRestricted } from '@src/hooks/useIsUserActionsRestricted';
import ChosenFileList from '@src/interfaces/ChosenFileList';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import { setState, toggleState } from '@src/store/reducers/UIReducer';
import {
	ActionIcon,
	ActionSeparator,
	ActionsRow,
	ActionsRowLeft,
	ActionsRowRight,
	AttachmentContainer,
	AttachmentOptionDocument,
	AttachmentOptionImageAndVideo,
	AttachmentOptions,
	CommandActionIcon,
	Container,
	EmojiPickerContainer,
	Footer,
	Row,
	ScrollButton,
	ScrollButtonWrapper,
	TypeBox,
	TypeBoxEditable,
	TypeBoxHint,
} from './ChatFooter.styles';

interface Props {
	waId: string | undefined;
	currentNewMessages: number;
	customerLanguage?: string | null;
	replyPreviewVisible?: boolean;
 onPrivateModeChange?: (value:boolean)=>void;
	isExpired: boolean;
	input: string;
	setInput: (value: string) => void;
	sendMessage: (
		willQueue: boolean,
		e?: Event | React.KeyboardEvent | React.MouseEvent,
		customPayload?: object,
		successCallback?: () => void,
		completeCallback?: () => void
	) => void | Promise<boolean | void>;
	setSelectedFiles: (value: any) => void;
	accept: string;
	setAccept: (value: string) => void;
	sendHandledChosenFiles: (files: ChosenFileList) => void;
	isScrollButtonVisible: boolean;
	handleScrollButtonClick: () => void;
	processCommand: (text: string) => void;
}

const ChatFooter: React.FC<Props> = ({
	waId,
	currentNewMessages,
	customerLanguage,
	replyPreviewVisible=false,
 onPrivateModeChange,
	isExpired,
	input,
	setInput,
	sendMessage,
	setSelectedFiles,
	accept,
	setAccept,
	sendHandledChosenFiles,
	isScrollButtonVisible,
	handleScrollButtonClick,
	processCommand,
}) => {
	const { t } = useTranslation();

	const dispatch = useAppDispatch();

	const {
		isTemplatesVisible,
		isSavedResponsesVisible,
		isInteractiveMessagesVisible,
	} = useAppSelector((state) => state.UI);

	const isUserActionsRestricted = useIsUserActionsRestricted();
 const staffId=useAppSelector(state=>state.currentUser?.value?.id)||0;
 const [privatePhone,setPrivatePhone]=useState<string|null>(null);
 const privateMode=!!waId&&privatePhone===waId;
 useEffect(()=>{onPrivateModeChange?.(privateMode);},[privateMode,onPrivateModeChange]);
 useEffect(()=>{setPrivatePhone(null);},[waId]);
 const enterPrivateMode=()=>{
  if(!waId||isRecording)return;
  writingRequest.current++;setWriting(null);setTemplateDraft(null);
  setQuickActionsMenuVisible(false);setAttachmentOptionsVisible(false);setEmojiPickerVisible(false);
  dispatch(setState({isTemplatesVisible:false,isSavedResponsesVisible:false,isInteractiveMessagesVisible:false}));
  setPrivatePhone(waId);
 };
 const canComposeClosed=window.config?.APP_ENV_NAME==='cvparc-shadow'&&isExpired&&!isUserActionsRestricted;
 const [templateDraft,setTemplateDraft]=useState<string|null>(null);
 useEffect(()=>{setTemplateDraft(null);},[waId,isExpired]);
 useEffect(()=>{if(isTemplatesVisible)setTemplateDraft(null);},[isTemplatesVisible]);
 const submitComposer=(e:React.MouseEvent|React.KeyboardEvent)=>{
  if(privateMode){e.preventDefault();return;}
  if(canComposeClosed){e.preventDefault();const draft=translateHTMLInputToText(editable.current?.innerHTML||input).trim();if(draft){dispatch(setState({isTemplatesVisible:false,isSavedResponsesVisible:false,isInteractiveMessagesVisible:false}));setQuickActionsMenuVisible(false);setTemplateDraft(draft);}return;}
  if(templateDraft!==null){e.preventDefault();return;}
  sendMessage(true,e);
 };

	const fileInput = useRef<HTMLInputElement>(null);
	const editable = useRef<HTMLDivElement>(null);

	const [isAttachmentOptionsVisible, setAttachmentOptionsVisible] =
		useState(false);
	const [isEmojiPickerVisible, setEmojiPickerVisible] = useState(false);
	const [contactsModalVisible, setContactsModalVisible] = useState(false);
	const [locationModalVisible, setLocationModalVisible] = useState(false);
	const [isQuickActionsMenuVisible, setQuickActionsMenuVisible] =
		useState(false);

	const [isRecording, setRecording] = useState(false);
	const [writing, setWriting] = useState<{loading:boolean; original:string; suggestion:string; error:string} | null>(null);
	const writingRequest = useRef(0);
	const [translationMode,setTranslationMode]=useState(false);
	const [targetLanguage,setTargetLanguage]=useState('');
	useEffect(()=>{setTargetLanguage(customerLanguage&&translationLanguages[customerLanguage]?customerLanguage:'');setTranslationMode(false);},[waId,customerLanguage]);
	useEffect(() => { writingRequest.current++; setWriting(null); }, [waId]);
	useEffect(() => () => { writingRequest.current++; }, []);
	const improveDraft = async (translate=false,target=targetLanguage) => {
		const original = translateHTMLInputToText(editable.current?.innerHTML || input).trim();
		if (!original || !waId || writing?.loading || isRecording) return;
		const request = ++writingRequest.current;
		setTranslationMode(translate);
		if(translate&&!target){setWriting({loading:false,original,suggestion:'',error:''});return;}
		setWriting({loading:true, original, suggestion:'', error:''});
		try {
			const response = await api.post(translate?'/translation/':'/writing-assistant/', {wa_id:waId, draft:original,target}, {timeout:45000});
			if (request !== writingRequest.current) return;
			setWriting({loading:false, original, suggestion:response.data.suggestion, error:''});
		} catch (error:any) {
			if (request !== writingRequest.current) return;
			setWriting({loading:false, original, suggestion:'', error:error.response?.data?.detail || 'No se ha podido mejorar el mensaje. Tu borrador sigue intacto.'});
		}
	};
	const discardWriting = () => { writingRequest.current++; setWriting(null); };
	const applyWriting = () => {
		if (!writing?.suggestion || translateHTMLInputToText(editable.current?.innerHTML || input).trim() !== writing.original) return;
		const safe = document.createElement('div'); safe.textContent = writing.suggestion;
		const html = safe.innerHTML.replace(/\n/g, '<br>');
		if (editable.current) editable.current.innerHTML = html;
		setInput(html); discardWriting(); editable.current?.focus();
	};

	const { insertAtCursor, handleCopy } = useChatFooter({ setInput });

	const handleAttachmentClick = (acceptValue: string) => {
		setAccept(acceptValue);

		fileInput.current?.setAttribute('accept', acceptValue);
		fileInput.current?.click();

		if (window.AndroidWebInterface) {
			window.AndroidWebInterface.requestPermissions();
		}
	};

	const handleEmojiPickerVisibility = function (msg: string, data: any) {
		setEmojiPickerVisible(data);
	};

	let timeout = useRef<NodeJS.Timeout>();
	const handleEditableChange = (event: React.FormEvent<HTMLDivElement>) => {
		if (timeout.current) {
			clearTimeout(timeout.current);
		}

		timeout.current = setTimeout(function () {
			setInput((event.target as HTMLDivElement).innerHTML);
		}, 5);
	};

	useEffect(() => {
		const token = PubSub.subscribe(
			EVENT_TOPIC_EMOJI_PICKER_VISIBILITY,
			handleEmojiPickerVisibility
		);

		return () => {
			PubSub.unsubscribe(token);
		};
	}, []);

	useEffect(() => {
		// Workaround for focused input for expired chats
		if (isExpired && !canComposeClosed) {
			editable.current?.blur();
		}

		// Focus on the message input when chat is loaded
		const eventToken = PubSub.subscribe(EVENT_TOPIC_FOCUS_MESSAGE_INPUT, () => {
			if (!isExpired || canComposeClosed) {
				editable.current?.focus();
			}
		});

		return () => {
			PubSub.unsubscribe(eventToken);
		};
	}, [editable.current, isExpired, canComposeClosed]);

	useEffect(() => {
		const preparedInput = translateHTMLInputToText(input).trim();
		if (preparedInput.startsWith('/')) {
			displayQuickActionsMenu();
		}
	}, [input]);

	// Track waId to detect chat switches (for draft restoration)
	const prevWaIdRef = useRef<string | undefined>(undefined);
	const prevInputRef = useRef(input);

	useEffect(() => {
		if (editable.current) {
			const waIdChanged = prevWaIdRef.current !== waId;
			const inputCleared = prevInputRef.current !== '' && input === '';
			// Also detect when input goes from empty to non-empty (draft restored after initial render)
			const inputRestored =
				prevInputRef.current === '' &&
				input !== '' &&
				editable.current.innerHTML === '';

			// Only update innerHTML when:
			// 1. waId changed (draft restoration when switching chats)
			// 2. input was cleared (message sent or cleared externally)
			// 3. input was restored (draft loaded after initial render)
			if (waIdChanged || inputCleared || inputRestored) {
				editable.current.innerHTML = input;

				// Move cursor to the end if there is actual text content
				const textContent = translateHTMLInputToText(input);
				if (textContent && textContent.trim().length > 0) {
					const moveCursorToEnd = () => {
						try {
							const el = editable.current;
							if (!el) return;

							// Focus is required for the cursor to be visible and correctly placed
							el.focus();

							const range = document.createRange();
							const selection = window.getSelection();

							if (selection) {
								range.selectNodeContents(el);
								range.collapse(false);
								selection.removeAllRanges();
								selection.addRange(range);
							}
						} catch (e) {
							console.warn('Failed to move cursor to end', e);
						}
					};

					// Execute immediately
					moveCursorToEnd();
					// And also on next tick to ensure DOM is ready
					setTimeout(moveCursorToEnd, 10);
				}
			}
		}
		prevWaIdRef.current = waId;
		prevInputRef.current = input;
	}, [editable, input, waId]);

	const toggleTemplateMessages = () => {
		setTemplateDraft(null);
		setQuickActionsMenuVisible(false);
		// If messages container is already scrolled to bottom
		/*const elem = messagesContainer.current;
		const offset = 5;

		let willScroll = false;
		if (elem.offsetHeight + elem.scrollTop >= (elem.scrollHeight - offset)) {
			willScroll = true;
		}*/

		if (!isTemplatesVisible) {
			setAttachmentOptionsVisible(false);
			dispatch(
				setState({
					isSavedResponsesVisible: false,
					isInteractiveMessagesVisible: false,
				})
			);
			setEmojiPickerVisible(false);
		}

		dispatch(toggleState('isTemplatesVisible'));
	};

	const toggleInteractiveMessages = () => {
		if (!isInteractiveMessagesVisible) {
			dispatch(
				setState({ isTemplatesVisible: false, isSavedResponsesVisible: false })
			);
			setAttachmentOptionsVisible(false);
			setEmojiPickerVisible(false);
		}

		dispatch(toggleState('isInteractiveMessagesVisible'));
	};

	const toggleSavedResponses = () => {
		if (!isSavedResponsesVisible) {
			setAttachmentOptionsVisible(false);
			dispatch(
				setState({
					isTemplatesVisible: false,
					isInteractiveMessagesVisible: false,
				})
			);
			setEmojiPickerVisible(false);
		}

		dispatch(toggleState('isSavedResponsesVisible'));
	};

	const toggleEmojiPicker = () => {
		setEmojiPickerVisible((prevState) => {
			if (!prevState) {
				dispatch(
					setState({
						isTemplatesVisible: false,
						isSavedResponsesVisible: false,
					})
				);
				setAttachmentOptionsVisible(false);
			}

			return !prevState;
		});
	};

	const handleEmojiSelect = (emoji: any) => {
		if (isRecording) {
			return;
		}

		if (editable.current) {
			// TODO: Try to avoid creating an emoji object here, if possible
			const emojiOutput = Emoji({
				html: true,
				emoji: emoji.colons,
				size: 22,
				set: EMOJI_SET,
				sheetSize: EMOJI_SHEET_SIZE,
			});

			insertAtCursor(editable.current, emojiOutput);
		}
	};

	const handlePaste = (event: React.ClipboardEvent<HTMLElement>) => {
		let text: string | undefined = event.clipboardData.getData('text/plain');
		text = replaceEmojis(text, true);
		insertAtCursor(editable.current, text);
		event.preventDefault();
	};

	const displayQuickActionsMenu = () => {
		if (!isQuickActionsMenuVisible) {
			setQuickActionsMenuVisible(true);
			dispatch(
				setState({ isTemplatesVisible: false, isSavedResponsesVisible: false })
			);
			setEmojiPickerVisible(false);
		}
	};

	const handleFocus = (event: React.FocusEvent<HTMLDivElement>) => {
		if (isRecording) {
			event.target.blur();
		}
	};

	const handleComposerClick = () => {
		if (isExpired && !canComposeClosed && !isUserActionsRestricted) {
			setQuickActionsMenuVisible(false);
			setAttachmentOptionsVisible(false);
			setEmojiPickerVisible(false);
			dispatch(setState({isTemplatesVisible:true,isSavedResponsesVisible:false,isInteractiveMessagesVisible:false}));
		}
	};

	const hasInput = () => {
		return input && input.length > 0;
	};

	const openContactsModal = () => {
		setContactsModalVisible(true);
	};

	const closeContactsModal = () => {
		setContactsModalVisible(false);
	};

	// https://developers.facebook.com/docs/whatsapp/on-premises/reference/media#supported-files
	const ACCEPT_IMAGE_AND_VIDEO = 'image/jpeg, image/png, video/mp4, video/3gpp';
	const ACCEPT_DOCUMENT = '*.*';

	return (
		<Container onDrop={(event) => event.preventDefault()}>
   {privateMode&&waId&&<InternalNoteComposer key={staffId+':'+waId} waId={waId} staffId={staffId} onClose={()=>setPrivatePhone(null)}/>}
   <div style={{display:privateMode?'none':undefined}}>
   {templateDraft!==null&&waId&&<TemplateAssistant key={waId+templateDraft} waId={waId} draft={templateDraft} currentDraft={translateHTMLInputToText(input).trim()} onClose={()=>setTemplateDraft(null)} onSend={async payload=>(await sendMessage(true,undefined,payload))===true}/>}
			{isQuickActionsMenuVisible && !isExpired && (
				<QuickActionsMenu
					input={translateHTMLInputToText(input).trim()}
					setInput={setInput}
					setVisible={setQuickActionsMenuVisible}
					onProcessCommand={processCommand}
					isExpired={isExpired}
				/>
			)}

			{isEmojiPickerVisible && (
				<EmojiPickerContainer>
					<NimblePicker
						set={EMOJI_SET}
						sheetSize={EMOJI_SHEET_SIZE}
						data={data}
						showPreview={false}
						emojiSize={32}
						onSelect={handleEmojiSelect}
					/>
				</EmojiPickerContainer>
			)}

			<ContactsModal
				open={contactsModalVisible}
				onClose={closeContactsModal}
				sendMessage={(payload, onSuccess) =>
					sendMessage(false, undefined, payload, onSuccess)
				}
				recipientWaId={waId}
			/>

			<LocationModal
				open={locationModalVisible}
				onClose={() => setLocationModalVisible(false)}
				sendMessage={(payload, onSuccess) =>
					sendMessage(false, undefined, payload, onSuccess)
				}
				recipientWaId={waId}
			/>

			<Row className={writing ? 'cv-writing-row' : ''}>
				<Footer className={isExpired && !canComposeClosed ? 'expired' : ''}>
					<form>
						<TypeBox className={'cv-public-composer '+(isExpired && !canComposeClosed ? 'expired ' : '') + (writing ? 'cv-writing-original' : '')}>
       <ActionIcon type="button" className="cv-composer-mode" aria-label="Cambiar a nota interna" disabled={!waId||isRecording||isUserActionsRestricted} onClick={enterPrivateMode}><WhatsAppIcon/></ActionIcon>
							{translateHTMLInputToText(input).trim() === '' && (
								<TypeBoxHint className="cv-composer-hint">
									{canComposeClosed ? <span>Escribe tu mensaje; usaremos la plantilla más adecuada para enviarlo</span> : isExpired ? (
										<span>
											{t(
												'This chat has expired. You need to answer with template messages.'
											)}
										</span>
									) : (
										<span>{t('Type a message')}</span>
									)}
								</TypeBoxHint>
							)}
							<TypeBoxEditable
        className="cv-composer-text"
								id="typeBox__editable"
								ref={editable}
								contentEditable="true"
								onFocus={handleFocus}
								onClick={handleComposerClick}
								onPaste={(event) => handlePaste(event)}
								onCopy={(event) => handleCopy(event)}
								onDrop={(event) => event.preventDefault()}
								spellCheck="true"
								onInput={(event) => handleEditableChange(event)}
								onKeyDown={(e: React.KeyboardEvent) => {
									if (e.keyCode === 13 && !e.shiftKey) submitComposer(e);
								}}
							/>
       <Tooltip title={t('Send')}><span><ActionIcon type="button" className="cv-composer-submit" aria-label="Enviar mensaje" data-test-id="send-message-button" disabled={!translateHTMLInputToText(input).trim()||isRecording} onClick={submitComposer}><Send/></ActionIcon></span></Tooltip>
						</TypeBox>
						<button
							onClick={submitComposer}
							type="submit"
							style={{ display: 'none' }}
						>
							{t('Send a message')}
						</button>
					</form>
				</Footer>
				{writing && <aside className={'cv-writing-proposal'+(translationMode?' cv-translation-proposal':'')} aria-live="polite">
					{!translationMode&&<div className="cv-writing-heading">Propuesta de SusIA</div>}
					<div className={'cv-writing-text' + (writing.loading ? ' cv-writing-loading' : '')}>{writing.loading ? (translationMode?'Traduciendo…':'Analizando conversación…') : writing.error || writing.suggestion}</div>
					{!writing.loading && writing.suggestion && translateHTMLInputToText(input).trim() !== writing.original && <div className="cv-writing-notice">Has cambiado el borrador. Vuelve a mejorarlo para no perder tus cambios.</div>}
					<div className="cv-writing-actions">
						{translationMode&&<Select className="cv-translation-language" size="small" displayEmpty inputProps={{'aria-label':'Idioma de traducción'}} value={targetLanguage} disabled={writing.loading} renderValue={value=>translationLanguages[value]||'Selecciona idioma'} MenuProps={{anchorOrigin:{vertical:'top',horizontal:'left'},transformOrigin:{vertical:'bottom',horizontal:'left'},PaperProps:{sx:{maxHeight:320,minWidth:200}},MenuListProps:{dense:true}}} onChange={e=>{setTargetLanguage(e.target.value);void improveDraft(true,e.target.value);}}>{Object.entries(translationLanguages).map(([code,name])=><MenuItem value={code} key={code}>{name}</MenuItem>)}</Select>}
						<button type="button" onClick={discardWriting}>Descartar</button>
						{translationMode&&writing.error&&<button type="button" className="cv-writing-use" disabled={!targetLanguage||writing.loading} onClick={()=>improveDraft(true)}>Reintentar</button>}
						{writing.suggestion && <button type="button" className="cv-writing-use" onClick={applyWriting} disabled={translateHTMLInputToText(input).trim() !== writing.original}>{translationMode?'Usar traducción':'Usar propuesta'}</button>}
					</div>
				</aside>}
			</Row>

   </div>
			<ActionsRow style={{visibility:privateMode?'hidden':undefined,pointerEvents:privateMode?'none':undefined}} aria-hidden={privateMode}>
				<ActionsRowLeft>
					{!isExpired && <Tooltip
						title="Mejorar mensaje"
						placement="top"
						disableInteractive
					>
						<CommandActionIcon
							className={writing && !translationMode ? 'active' : ''}
							onClick={()=>improveDraft()}
							disabled={!translateHTMLInputToText(input).trim() || writing?.loading || isRecording || isExpired}
							aria-label="Mejorar mensaje"
							size="small"
						>
							<AutoFixHighIcon />
						</CommandActionIcon>
					</Tooltip>}

					{!isExpired && <Tooltip title="Traducir mensaje" placement="top" disableInteractive><CommandActionIcon className={writing && translationMode ? 'active' : ''} aria-label="Traducir mensaje" size="small" disabled={!translateHTMLInputToText(input).trim()||writing?.loading||isRecording} onClick={()=>improveDraft(true)}><TranslateIcon/></CommandActionIcon></Tooltip>}
					{!isExpired && <ActionSeparator />}

					{!isUserActionsRestricted && (
						<Tooltip title={t('Templates')} placement="top" disableInteractive>
							<ActionIcon
								data-test-id="templates-button"
								onClick={toggleTemplateMessages}
								className={isTemplatesVisible ? 'active' : ''}
								size="small"
							>
								<SmsIcon />
							</ActionIcon>
						</Tooltip>
					)}

					{window.config?.APP_ENV_NAME !== 'cvparc-shadow' && !isExpired && !isUserActionsRestricted && (
						<Tooltip
							title={t('Interactive Messages')}
							placement="top"
							disableInteractive
							className={isAttachmentOptionsVisible ? 'desktopOnly' : ''}
						>
							<ActionIcon
								onClick={toggleInteractiveMessages}
								className={isInteractiveMessagesVisible ? 'active' : ''}
								size="small"
							>
								<TryIcon />
							</ActionIcon>
						</Tooltip>
					)}

					{window.config?.APP_ENV_NAME !== 'cvparc-shadow' && !isExpired && (
						<Tooltip
							title={t('Quick Replies')}
							placement="top"
							className={isAttachmentOptionsVisible ? 'desktopOnly' : ''}
							disableInteractive
						>
							<ActionIcon
								onClick={toggleSavedResponses}
								className={isSavedResponsesVisible ? 'active' : ''}
								size="small"
							>
								<NotesIcon />
							</ActionIcon>
						</Tooltip>
					)}

					{!isExpired && <ActionSeparator />}

					{!isExpired && (
						<Tooltip title={t('Emoji')} placement="top" disableInteractive>
							<ActionIcon
								className={isEmojiPickerVisible ? 'active' : ''}
								onClick={toggleEmojiPicker}
								size="small"
							>
								<InsertEmoticon />
							</ActionIcon>
						</Tooltip>
					)}

					{!isExpired && (
						<AttachmentContainer
							className={isAttachmentOptionsVisible ? 'open' : ''}
						>
							<Tooltip
								title={t('Attachment')}
								placement="top"
								disableInteractive
							>
								<ActionIcon
									className={isAttachmentOptionsVisible ? 'active' : ''}
									size="small"
									onClick={() =>
										setAttachmentOptionsVisible(!isAttachmentOptionsVisible)
									}
								>
									<AttachFile />
								</ActionIcon>
							</Tooltip>

							<Grow in={isAttachmentOptionsVisible} unmountOnExit>
								<AttachmentOptions>
									<Tooltip
										title={t('Images & Videos')}
										placement="top"
										disableInteractive
									>
										<AttachmentOptionImageAndVideo
											onClick={() =>
												handleAttachmentClick(ACCEPT_IMAGE_AND_VIDEO)
											}
											size="small"
										>
											<ImageIcon />
										</AttachmentOptionImageAndVideo>
									</Tooltip>

									<Tooltip
										title={t('Documents')}
										placement="top"
										disableInteractive
									>
										<AttachmentOptionDocument
											onClick={() => handleAttachmentClick(ACCEPT_DOCUMENT)}
											size="small"
										>
											<InsertDriveFileIcon />
										</AttachmentOptionDocument>
									</Tooltip>

									<Tooltip
										title={t('Contacts')}
										placement="top"
										disableInteractive
									>
										<ActionIcon onClick={openContactsModal} size="small">
											<ContactsIcon />
										</ActionIcon>
									</Tooltip>

									<Tooltip
										title={t('Location')}
										placement="top"
										disableInteractive
									>
										<ActionIcon
											onClick={() => setLocationModalVisible(true)}
											size="small"
										>
											<LocationOnIcon />
										</ActionIcon>
									</Tooltip>
								</AttachmentOptions>
							</Grow>
						</AttachmentContainer>
					)}
				</ActionsRowLeft>

				<ActionsRowRight>
					<div className={!isRecording ? 'hidden' : ''}>
						<VoiceRecord
							voiceRecordCase="chat"
							setRecording={setRecording}
							sendHandledChosenFiles={sendHandledChosenFiles}
						/>
					</div>

					{!isExpired && !hasInput() && !isRecording && (
						<Tooltip title={t('Voice')} placement="top" disableInteractive>
							<ActionIcon
								onClick={() =>
									PubSub.publish(EVENT_TOPIC_REQUEST_MIC_PERMISSION, 'chat')
								}
								size="small"
							>
								<MicIcon />
							</ActionIcon>
						</Tooltip>
					)}

				</ActionsRowRight>
			</ActionsRow>
   <div style={{display:privateMode?'none':undefined}}>
			<div className="hidden">
				<FileInput
					innerRef={fileInput}
					accept={accept}
					handleSelectedFiles={(files) => {
						if (
							accept !== ACCEPT_DOCUMENT &&
							!ACCEPT_IMAGE_AND_VIDEO.includes(files[0].type)
						) {
							window.displayCustomError(
								t('Please choose a supported file type (png, jpg, mp4, 3gp)')
							);

							return;
						}

						setSelectedFiles({ ...files });
					}}
				/>
			</div>

   </div>
			<Zoom in={isScrollButtonVisible}>
				<ScrollButtonWrapper
					style={{bottom:replyPreviewVisible?190:112}}
					color="primary"
					overlap="rectangular"
					badgeContent={currentNewMessages}
					invisible={currentNewMessages === 0}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					<ScrollButton onClick={handleScrollButtonClick} size="small">
						<ArrowDownward />
					</ScrollButton>
				</ScrollButtonWrapper>
			</Zoom>
		</Container>
	);
};

export default ChatFooter;
